import { HttpErrorResponse } from '@angular/common/http';
import { ErrorHandler, Injectable } from '@angular/core';
import { ExceptionTrackingService } from './exception-tracking.service';

@Injectable({
  providedIn: 'root'
})
export class LoginModalErrorHandlerService extends ErrorHandler {
  constructor(public exceptionTrackingService: ExceptionTrackingService) {
    super();
    this.exceptionTrackingService = exceptionTrackingService;
  }

  handleError(error: HttpErrorResponse) {
    this.exceptionTrackingService.track(error);
  }
}
